module.exports = __webpack_public_path__ + "static/media/DSC_0179-2.25612313.jpg";